module.exports = __webpack_public_path__ + "static/img/shezhi_qianbao.c417da0e.png";